import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface InterviewContextType {
  isInterviewActive: boolean;
  setInterviewActive: (active: boolean) => void;
}

const InterviewContext = createContext<InterviewContextType | undefined>(undefined);

export function InterviewProvider({ children }: { children: ReactNode }) {
  const [isInterviewActive, setIsInterviewActive] = useState(false);

  const setInterviewActive = useCallback((active: boolean) => {
    console.log('[InterviewContext] Setting interview active:', active);
    setIsInterviewActive(active);
  }, []);

  return (
    <InterviewContext.Provider value={{ isInterviewActive, setInterviewActive }}>
      {children}
    </InterviewContext.Provider>
  );
}

export function useInterviewContext() {
  const context = useContext(InterviewContext);
  if (!context) {
    throw new Error('useInterviewContext must be used within InterviewProvider');
  }
  return context;
}

// Optional hook that doesn't throw if provider is missing
export function useOptionalInterviewContext() {
  return useContext(InterviewContext);
}
